import React from 'react';
import { Dialog } from '@headlessui/react';

export default function Modal({ isOpen, onClose, children }) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-dark-200 rounded-lg shadow-xl relative flex flex-col">
        {children}
      </div>
    </div>
  );
} 